// Identificadores públicos do Cognito (não são segredos — equivalem à URL da API).
// Pool `era-admin` (Essentials, passwordless EMAIL_OTP), client `era-admin-web`.
// Ver docs/AUTH_COGNITO.md. Usuários: só os criados via admin-create-user.

export const COGNITO_REGION = 'sa-east-1';
export const COGNITO_USER_POOL_ID = 'sa-east-1_SEgh3gsYq';
export const COGNITO_CLIENT_ID = '7cbnbkkc4karfnqnqdnll3t0t3';
export const COGNITO_ENDPOINT = `https://cognito-idp.${COGNITO_REGION}.amazonaws.com/`;

async function cognitoCall(target: string, payload: unknown): Promise<any> {
  const response = await fetch(COGNITO_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': `AWSCognitoIdentityProviderService.${target}`,
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err: any = new Error(data.message || `Falha na autenticação (${target})`);
    err.name = data.__type || 'CognitoError';
    throw err;
  }
  return data;
}

/** Passo 1: informa o email → Cognito envia o código OTP. Retorna a Session. */
export async function startEmailOtp(email: string): Promise<string> {
  const data = await cognitoCall('InitiateAuth', {
    AuthFlow: 'USER_AUTH',
    ClientId: COGNITO_CLIENT_ID,
    AuthParameters: { USERNAME: email.trim().toLowerCase(), PREFERRED_CHALLENGE: 'EMAIL_OTP' },
  });
  if (data.ChallengeName !== 'EMAIL_OTP' || !data.Session) {
    throw new Error('Conta sem login por código habilitado. Fale com o administrador.');
  }
  return data.Session as string;
}

/** Passo 2: confirma o código → retorna o IdToken JWT. */
export async function confirmEmailOtp(email: string, code: string, session: string): Promise<string> {
  // Alguns clientes de email quebram o código com espaços/quebras — remove tudo.
  const cleanCode = code.replace(/\s/g, '');
  const data = await cognitoCall('RespondToAuthChallenge', {
    ClientId: COGNITO_CLIENT_ID,
    ChallengeName: 'EMAIL_OTP',
    Session: session,
    ChallengeResponses: {
      USERNAME: email.trim().toLowerCase(),
      EMAIL_OTP_CODE: cleanCode,
    },
  });
  const idToken = data?.AuthenticationResult?.IdToken;
  if (!idToken) {
    throw new Error('Código inválido ou expirado. Peça um novo código.');
  }
  return idToken as string;
}

export function friendlyAuthError(err: any): string {
  const name = String(err?.name || '');
  const message = String(err?.message || '');
  if (name.includes('UserNotFound')) return 'Email não cadastrado. Fale com o administrador.';
  if (name.includes('CodeMismatch') || /invalid code/i.test(message)) {
    return 'Código incorreto. Confira o último código enviado ao seu email (códigos anteriores expiram).';
  }
  if (name.includes('NotAuthorized')) return 'Código inválido ou expirado. Peça um novo código.';
  if (name.includes('TooManyRequests') || name.includes('LimitExceeded')) {
    return 'Muitas tentativas. Aguarde alguns minutos e tente de novo.';
  }
  return err?.message || 'Erro na autenticação. Tente novamente.';
}
